import styled from 'styled-components';
import PropTypes from 'prop-types';
import styleHelper from '@utils/styleHelper';
import { TextColors, Fonts, Spacings } from '../../../styleConstants';

const P1 = styled.p`
  font-weight: ${Fonts.REGULAR};
  font-size: ${Fonts.P1};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  color: ${({ color }) => color};
  margin: ${Spacings.SPACING_0B};
  ${({ lineClamp }) =>
    lineClamp ? styleHelper.lineClampStyle(lineClamp) : null}
`;

export default P1;

P1.propTypes = {
  color: PropTypes.string,
  lineClamp: PropTypes.number
};

P1.defaultProps = {
  color: TextColors.BLACK,
  lineClamp: null
};
